import { Checkbox, Grid, IconButton, Stack, Typography } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import AddIcon from "@mui/icons-material/Add";
import SaveIcon from "@mui/icons-material/Save";
import { DataGrid } from "@mui/x-data-grid";
import { useDispatch, useSelector } from "react-redux";
import CancelIcon from "@mui/icons-material/Cancel";
import DialogBoxComp from "../../../components/common/DialogBox/DialogBoxComp";
import ScreenCard from "../../../components/common/ScreenCard/ScreenCard";
import TableComp from "../../../components/common/TableComp/TableComp";
import InputWithBtnLayoutComp from "../../../components/InputWithBtnLayout/InputWithBtnLayoutComp";
import InputComp from "../../../components/common/InputComp/Input";
import TabComp from "../../../components/TabsComp/TabComp";
import Btn from "../../../components/common/ButtonComp/Btn";
import { asyncStatus } from "../../../utils/asyncStatus";
import { primaryColor } from "../../../utils/themeColors";
import {
  addOMShipViaAsync,
  deleteOMShipViaAsync,
  editOMShipViaAsync,
  getOMShipViaAsync,
} from "../../../store/services/orderManagementService";
const ShipVia = () => {
  const dispatch = useDispatch();
  const {
    getOMShipViaStatus,
    getOMShipViaError,
    getOMShipViaData,
    addOMShipViaStatus,
    addOMShipViaData,
    addOMShipViaError,

    editOMShipViaStatus,
    editOMShipViaError,
    editOMShipViaData,

    deleteOMShipViaData,
    deleteOMShipViaStatus,
    deleteOMShipViaError,
  } = useSelector((state) => state.om);

  useEffect(() => {
    dispatch(getOMShipViaAsync());
  }, []);

  // console.log("getProductStyleData", getProductStyleData);
  const formattedData = getOMShipViaData?.length
    ? getOMShipViaData.map((style, index) => ({
        id: index + 1, // Assuming the index is a unique identifier for each row
        ...style,
      }))
    : [];
  const [selectedShipVia, setSelectedShipVia] = useState();
  const [addShipViaMode, setAddShipViaMode] = useState(false);
  const [addShipViaData, setAddShipViaData] = useState();
  const [saveDisabled, setSaveDisabled] = useState(true);
  const [editData, setEditData] = useState();
  const [editMode, setEditMode] = useState(false);
  // console.log("selectedShipVia", selectedShipVia);
  // console.log("editData", editData);
  useEffect(() => {
    if (addOMShipViaStatus === asyncStatus.SUCCEEDED) {
      setAddShipViaMode(false);
      setSaveDisabled(true);
      setAddShipViaData();
    }
  }, [, addOMShipViaStatus]);

  const [open, setOpen] = useState(false);
  const agree = () => {
    dispatch(deleteOMShipViaAsync(selectedShipVia?.ship_via_id));
  };
  const handleClose = () => {
    setOpen(false);
  };
  useEffect(() => {
    if (deleteOMShipViaStatus === asyncStatus.SUCCEEDED || deleteOMShipViaStatus === asyncStatus.ERROR ) {
      setOpen(false);
      setSelectedShipVia();
    }
  }, [, deleteOMShipViaStatus]);
  useEffect(() => {
    if (editOMShipViaStatus === asyncStatus.SUCCEEDED) {
      setSelectedShipVia();
      setEditMode(false);
      setEditData()
    }
  }, [, editOMShipViaStatus]);

  //   const [tableHeight, setTableHeight] = useState("");
  //   let elem = document.getElementById("containerHeight");
  //   useEffect(() => {
  //     console.log("elem?.offsetHeight",elem?.clientHeight);
  //     setTableHeight(elem?.offsetHeight);
  //   }, [ elem?.offsetHeight]);
  // console.log(containerHeight)
  return (
    <Stack padding={2}>
      <DialogBoxComp
        open={open}
        handleClose={handleClose}
        agree={agree}
        innerContent={"Are you sure you want to delete this ship via?"}
        heading={"Delete request"}
      />
      <ScreenCard
        title="Ship Via"
        customHeader={
          <Stack
            sx={{
              padding: 0.5,
              px: 4,
              backgroundColor: primaryColor,
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Typography sx={{ color: "white", fontWeight: "bold" }}>
              Ship Via
            </Typography>
            <Stack flexDirection={"row"} gap={1}>
              <IconButton
                onClick={() => {
                  setEditMode(false);
                  setAddShipViaMode((prev) => !prev);
                  setSaveDisabled(false);
                }}
              >
                {!addShipViaMode ? (
                  <AddIcon sx={{ color: "white" }} />
                ) : (
                  <CancelIcon sx={{ color: "white" }} />
                )}
              </IconButton>
              <IconButton
                disabled={addShipViaMode}
                sx={{ color: "white", ":disabled": { color: "gray" } }}
                onClick={() => {
                  setAddShipViaMode(false);
                  setEditMode((prev) => !prev);
                  setSaveDisabled(false);
                }}
              >
                {!editMode ? (
                  <EditIcon />
                ) : (
                  <CancelIcon sx={{ color: "white" }} />
                )}
              </IconButton>
              <IconButton
                disabled={addShipViaMode || !selectedShipVia}
                sx={{ color: "white", ":disabled": { color: "gray" } }}
                onClick={() => setOpen(true)}
              >
                <DeleteIcon />
              </IconButton>
              <IconButton
                disabled={
                  addOMShipViaStatus === asyncStatus.LOADING ||
                  editOMShipViaStatus === asyncStatus.LOADING ||
                  saveDisabled
                }
                sx={{ color: "white", ":disabled": { color: "gray" } }}
                onClick={() => {
                  if (addShipViaData) {
                    dispatch(addOMShipViaAsync(addShipViaData));
                  } else if (editMode) {
                    let a;
                    a = { ...selectedShipVia, ...editData };
                    delete a.id;
                    dispatch(editOMShipViaAsync(a));
                  }
                }}
              >
                <SaveIcon />
              </IconButton>
            </Stack>
          </Stack>
        }
      >
        <Grid container>
          <Grid item xl={3} lg={3} md={3} sm={12} xs={12}>
            <Stack height={500} width={"100%"}>
              <TableComp
                columns={[
                  { field: "ship_via_id", headerName: "ID", flex: true },
                  { field: "ship_via_description", headerName: "Ship Via", flex: true },
                ]}
                onRowClick={(e) => {
                  setSelectedShipVia(e?.row);
                }}
                rows={formattedData}
                loading={
                  getOMShipViaStatus === asyncStatus.IDLE ||
                  getOMShipViaStatus === asyncStatus.LOADING
                }
              />
            </Stack>
          </Grid>
          <Grid item xl={9} lg={9} md={9} sm={12} xs={12} padding={2}>
            {addShipViaMode ? (
              <InputWithBtnLayoutComp
              error={addOMShipViaError}
                inputArray={[
                  {
                    label: "Ship Via:",
                    comp: (
                      <InputComp
                        style={{ borderRadius: 5, fontSize: 12, padding: 4 }}
                        placeholder=""
                        onChange={(e) =>
                          setAddShipViaData({
                            ...addShipViaData,
                            ship_via_description: e.target.value,
                          })
                        }
                      />
                    ),
                  },
                  {
                    label: "Active:",
                    comp: (
                      <Checkbox
                        defaultChecked
                        defaultValue={true}
                        onChange={(e) =>
                          setAddShipViaData({
                            ...addShipViaData,
                            is_active: e.target.checked,
                          })
                        }
                      />
                    ),
                  },
                ]}
                secondaryComp={<></>}
              />
            ) : selectedShipVia ? (
              <InputWithBtnLayoutComp
              error={editOMShipViaError}
                inputArray={[
                  {
                    label: "ID:",
                    comp: (
                      <Typography sx={{ fontSize: 14 }}>
                        {selectedShipVia?.ship_via_id}
                      </Typography>
                    ),
                  },
                  {
                    label: "ShipVia:",
                    comp: (
                      <InputComp
                        key={selectedShipVia?.ship_via_id} // Add key prop to force remount
                        disabled={!editMode}
                        onChange={(e) =>
                          setEditData({
                            ...editData,
                            ship_via_description: e.target.value,
                          })
                        }
                        style={{ borderRadius: 5, fontSize: 12, padding: 4 }}
                        placeholder=""
                        defaultValue={selectedShipVia?.ship_via_description}
                      />
                    ),
                  },
                  {
                    label: "Active:",

                    comp: (
                      <Checkbox
                        onChange={(e) =>
                          setEditData({
                            ...editData,
                            is_active: e.target.checked,
                          })
                        }
                        value={selectedShipVia?.is_active|| editData?.is_active}
                        disabled={!editMode}
                        // defaultValue={selectedShipVia?.is_active || editData?.is_active}
                        defaultChecked={selectedShipVia?.is_active || editData?.is_active}
                        // checked={selectedShipVia?.is_active}
                      />
                    ),
                  },
                ]}
                secondaryComp={
                  <Btn
                    style={{ fontSize: 10, fontWeight: "bold" }}
                    disabled={editMode}
                  >
                    Assign Companies
                  </Btn>
                }
              />
            ) : (<Stack>
              <Typography>Select any ship via</Typography>
              <Typography color={"red"} fontSize={12}>{getOMShipViaError}</Typography>
            </Stack>
            )}
            <Stack my={2}>
              <TabComp
                tabs={[
                  //   {
                  //     name: "Companies",
                  //     content: (
                  //       <Stack height={400} width={"100%"}>
                  //         <TableComp
                  //           columns={[
                  //             {
                  //               field: "companyId",
                  //               headerName: "Company ID",
                  //               flex: true,
                  //             },
                  //             {
                  //               field: "companyName",
                  //               headerName: "Company Name",
                  //               flex: true,
                  //             },
                  //             {
                  //               field: "action",
                  //               headerName: "Action",
                  //               flex: true,
                  //             },
                  //           ]}
                  //           //   onRowClick={(e) => {
                  //           //     setSelectedShipVia(e?.row);
                  //           //   }}
                  //           rows={[]}
                  //           //   loading={
                  //           //     getProductStyleStatus === asyncStatus.IDLE ||
                  //           //     getProductStyleStatus === asyncStatus.LOADING
                  //           //   }
                  //         />
                  //       </Stack>
                  //     ),
                  //   },
                  {
                    name: "Log Info",
                    content: (
                      <Stack height={400} width={"100%"}>
                        <TableComp
                          columns={[
                            {
                              field: "logId",
                              headerName: "Log ID",
                              flex: true,
                            },
                            {
                              field: "recordId",
                              headerName: "Record_id",
                              flex: true,
                            },
                            {
                              field: "columnName",
                              headerName: "Column Name",
                              flex: true,
                            },
                            {
                              field: "columnValue",
                              headerName: "Column Value",
                              flex: true,
                            },
                            {
                              field: "actionName",
                              headerName: "Action Name",
                              flex: true,
                            },
                            {
                              field: "actionDate",
                              headerName: "Action Date",
                              flex: true,
                            },
                            {
                              field: "userId",
                              headerName: " User ID",
                              flex: true,
                            },
                          ]}
                          //   onRowClick={(e) => {
                          //     setSelectedShipVia(e?.row);
                          //   }}
                          rows={[]}
                          //   loading={
                          //     getProductStyleStatus === asyncStatus.IDLE ||
                          //     getProductStyleStatus === asyncStatus.LOADING
                          //   }
                        />
                      </Stack>
                    ),
                  },
                ]}
              />
            </Stack>
          </Grid>
        </Grid>

        {/* <div style={{ height: 400, width: '100%' }}>
      <DataGrid
      sty
        rows={rows}
        columns={columns}
        initialState={{
          pagination: {
            paginationModel: { page: 0, pageSize: 5 },
          },
        }}
        pageSizeOptions={[5, 10]}
        // checkboxSelection
      />
    </div> */}
      </ScreenCard>
    </Stack>
  );
};

export default ShipVia;
